import { useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import Charts from './Charts'
import { FeedbackContext } from "../Context/FeedbackContext";
import { Loading } from "../Loading/Loading";
import { ErrorConnection } from "../Error/Error";
import { Spinner } from 'react-bootstrap';

function ChartFromServer({ setAuxData, apiService, args, conditions, type, idContent, classContent, dataSeries, settings, colorList, setEnableQuery, initialDate = null, endDate = null }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError, error, isFetching } = useQuery([idContent, args],
        async () => await apiService(args),
        {
            enabled: conditions
        }
    );


    useEffect(() => {
        if (data) {
            setEnableQuery && setEnableQuery(false); //Everytime the query fetches data, it disables the useQuery condition
            if (/* !data.success || */data.data === null) { // 2do release. El data.success sirve para ver si la consulta da o no resultado, así que no se valida aquí.
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
            else if (data.data?.auxData)
                setAuxData(data.data.auxData);
        }
    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <>
            {isFetching && <Spinner animation="grow" variant="secondary" />}
            {(data?.data?.graph) && (
                <>
                    <Charts
                        type={type}
                        idContent={idContent}
                        data={data.data.graph}
                        dataSeries={dataSeries ?
                            dataSeries :
                            data.data.options}
                        colorList={colorList}
                        settings={settings}
                        classContent={classContent}
                        initialDate={initialDate}
                        endDate={endDate}
                    />
                </>
            )
            }
        </>
    )
}

export default ChartFromServer
